import { takeLatest, call, put } from 'redux-saga/effects'
import { editOpenEndedQuestion } from 'api/administration/questions/Edit'
import { getQuestionList } from 'api/administration/questions/List'
import { IOpenEndedModel } from 'models/questionOpenEnded.model'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/questions.action'

async function getList(instanceId: number) {
  return await getQuestionList(instanceId)
}

async function handleEditOpenEnded(data: IOpenEndedModel, questionId: number) {
  return await editOpenEndedQuestion(data, questionId)
}

function* editOpenEndedEffectSaga(action: any) {
  try {
    const {
      data: { data, instanceId, questionId },
    } = action
    yield call(handleEditOpenEnded, data, questionId)
    const questionList = yield call(getList, instanceId)
    yield put(fromActions.Actions.questionsListSuccess(questionList))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    // Without this the question editor and cards stay behind a loader.
    yield put(fromActions.Actions.setQuestionLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editOpenEndedWatcherSaga() {
  yield takeLatest(fromActions.QUESTION_OPENENDED_EDIT, editOpenEndedEffectSaga)
}
